"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "@/lib/cwfNavigation";
import { useQuery } from "@tanstack/react-query";
import { apiJson } from "@/lib/api";
import { useHydratedSession } from "@/hooks/useHydratedSession";
import { useSession } from "@/stores/session";
import { hasReplayWelcomeDebugFlag } from "@/lib/cwfHomeDebug";

const EXEMPT_PREFIXES = ["/login", "/welcome"];

type MeGate = {
  profileSetupComplete?: boolean;
};

export function ProfileSetupGate() {
  const router = useRouter();
  const pathname = usePathname();
  const token = useSession((s) => s.token);
  const hydrated = useHydratedSession();

  const exempt = EXEMPT_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));

  const me = useQuery({
    enabled: hydrated && !!token && !exempt,
    queryKey: ["me", token],
    queryFn: () => apiJson<MeGate>("/me", { token }),
    staleTime: 15_000,
  });

  useEffect(() => {
    if (!hydrated || !token || exempt) return;
    if (!me.isSuccess || !me.data) return;
    if (me.data.profileSetupComplete === false) {
      router.replace("/welcome");
    }
  }, [hydrated, token, exempt, me.isSuccess, me.data, router]);

  useEffect(() => {
    if (!hydrated || !token || pathname !== "/welcome") return;
    if (!me.isSuccess || !me.data) return;
    if (me.data.profileSetupComplete === true && !hasReplayWelcomeDebugFlag()) {
      router.replace("/");
    }
  }, [hydrated, token, pathname, me.isSuccess, me.data, router]);

  return null;
}
